<div class="cluster-list" [resBusySpinner]="isBusyLoading" [message]="isBusyLoadingMessage" id="clusterListContainer">
    <div class="breadcrumb-widget" [hidden]="!parentView">
        <div class="breadcrumb-item-group">
            <span *ngIf="clustersOutofDate">
                <div class="text">
                    <i class="fa fa-exclamation-triangle color-tan-07" data-automation-id="cluster-summary-data-out-of-date-icon"
                        [title]="outofDateClusterViewName + ' has been changed. Clusters are out of date.'"></i>Clusters
                    are out of date.
                </div>
            </span>
        </div>
        <div class="breadcrumb-buttons">
            <button type="button" [attr.data-automation-id]="automationId + '-cluster-rebuild-all-button'"
                class="secondary-button right" (click)="openRebuildCluster()" [disabled]="!rebuildButton">
                <i class="fa fa-retweet"></i>Rebuild ...</button>
            <button type="button" [attr.data-automation-id]="automationId + '-generate-report-button'"
                class="secondary-button right" (click)="openGenerateClusterReport()" *ngIf="generateReportVisible">
                <div class="iconContainer">
                    <span class="fa-stack">
                        <i class="iconFirst fa-stack-1x fa fa-list-alt color-blue-grey-03"></i>
                        <i class="iconSecond fa-stack-1x fa fa-retweet color-blue-01"></i>
                    </span>
                    <span class="btn-label">Generate Report ...</span>
                </div>
            </button>
            <button type="button" [attr.data-automation-id]="automationId + '-cluster-update-button'"
                class="secondary-button right" (click)="updateCluster()" [disabled]="!updateButtonEnabled">
                <i class="fa fa-refresh"></i>Update</button>
            <button type="button" class="help-button" [attr.data-automation-id]="automationId + '-cluster-help-button'"
                (click)="openHelp()"> <i class="fa fa-question"></i>
            </button>
        </div>
    </div>

    <div class="cluster-list-top" id="clusterListTop">
        <res-generic-grid *ngIf="parentView" [gridName]="gridName" [automationId]="automationId" [helpIndex]="helpIndex"
            [updateStatusType]="updateStatusType" [(isBusy)]="isBusy" [(isBusyMessage)]="isBusyMessage"
            [headerTemplate]="headerTemplate" [columnDefs]="columnDefs" [cellClickedCallback]="cellClickedCallback"
            [requestInfo]="requestInfo" [gridContext]="gridContext" [contextMenuOptions]="contextMenuOptions"
            [rowClassRules]="rowClassRules" [responseCallback]="responseCallback"
            [responseArrayCallback]="responseArrayCallback" [onSelectionChanged]="onSelectionChanged"
            [loadDataFinishedCallback]="loadDataFinishedCallback" [rowsHaveTreeGrouping]="true" [pagerVisible]="true"
            [onRowClickedCallback]="onRowClickedCallback">
        </res-generic-grid>
    </div>

    <res-resizer anchor="up" [ellipsisExpander]="true" resizingElementId="clusterListTop"
        secondElementId="clusterListBottom" [initSize]="220" [minSize]="220" [maxSize]="500" [hidden]="!parentView">
    </res-resizer>

    <div class="cluster-list-bottom" id="clusterListBottom">
        <res-document-list [hidden]="!selectedTreeItem"></res-document-list>
    </div>

    <div class="create-cluster-list-container" [hidden]="!generateButtonVisible">
        <div class="create-cluster-list-container-button">
            <button type="button" [hidden]="isBusyLoading" [attr.data-automation-id]="automationId + '-generate-button'"
                class="primary-button" (click)="openBuildCluster()">Build Clusters ...</button>
        </div>
    </div>
</div>